function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#3E4C57",
  fillRule: "evenodd",
  stroke: "#3E4C57",
  strokeWidth: 0.2,
  d: "M17.94 8.705l-.014.008-2.579-6.417h1.177a.382.382 0 0 0 0-.764H9.335V.428a.382.382 0 0 0-.764 0v1.1H1.387a.382.382 0 0 0 0 .764h1.226L.03 8.705A.382.382 0 0 0 0 8.846a3.176 3.176 0 1 0 6.352 0 .382.382 0 0 0-.03-.141L3.742 2.288h4.828v11.81c-1.822.138-3.246 1.245-3.246 2.586 0 .211.17.382.382.382H12.2c.21 0 .382-.17.382-.382 0-1.34-1.425-2.448-3.247-2.586V2.288h4.878L11.65 8.705a.382.382 0 0 0-.03.141 3.176 3.176 0 1 0 6.351 0 .382.382 0 0 0-.03-.141zm-14.766 2.56a2.414 2.414 0 0 1-2.38-2.03h4.744a2.414 2.414 0 0 1-2.364 2.03zm2.227-2.793H.955L3.182 2.93 5.4 8.472zm6.348 7.83H6.153c.283-.821 1.448-1.455 2.796-1.455 1.349 0 2.518.634 2.8 1.455zm3.03-13.369l2.218 5.539h-4.446l2.227-5.539zm0 8.331v.004a2.414 2.414 0 0 1-2.365-2.032h4.744a2.414 2.414 0 0 1-2.38 2.028z"
});

var SvgWeight = function SvgWeight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWeight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/weight.caa336d8.svg";
export { ForwardRef as ReactComponent };